<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 5px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 140px;}
.ziduanKey /deep/ .el-input__inner {width: 140px;}
.sort /deep/ .el-input__inner {width: 130px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
.sendform {display: flex;flex-direction: column;justify-content: center;}
.sendform .el-form-item {margin-bottom: 22px;}
.el-select {width: 100%;}
.el-date-editor {width: 100%;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.username" placeholder="请输入会员名" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.company" placeholder="请输入公司" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.email" placeholder="请输入邮箱" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
               <el-form-item>
                <div class="td">
                  <el-input v-model="form.mobile" placeholder="请输入手机号" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select clearable v-model="form.sort" placeholder="结果排序方式" class="select sort">
                    <el-option v-for="item in member_data" :key="item.value" :label="item.label" :value="item.description"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select clearable v-model="form.areaid" class="select select1" placeholder="请选择地区">
                    <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.count" placeholder="20" class="input count"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button class="elbtn search" @click="search">搜索</el-button>
                  <el-button class="elbtn reset" @click="cancelfnBtn()">重置</el-button>
                  <el-button type="success" v-if="parms === 'Membergl'" @click="addfn()">添加</el-button>
                  <el-button type="primary" v-if="parms === 'Membergl'" @click="sendtype()">消息发送</el-button>
                  <el-button type="primary" v-if="parms === 'Membergl'" @click="systemtype()">系统消息发送</el-button>

                </div>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>

      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="username" label="会员名" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="passport" label="昵称" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="company" label="公司" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="mobile" label="手机号" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true"> </el-table-column>
          <el-table-column label="添加时间" width="170">
            <template slot-scope="scope">{{ (scope.row.regtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" @click="deletefn(11, 28, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button type="danger" class="elbtn delete" @click="deletesfn(11, 28)">批量删除</el-button>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>

    <el-dialog
      title="提示"
      center
      :visible.sync="dialogVisible">
      <el-form :model="sendform" class="sendform">
        <el-form-item label="发送方式：" :label-width="formLabelWidth">
          <el-radio-group v-model="sendform.type">
            <el-radio label="email">邮箱</el-radio>
            <el-radio label="mobile">手机</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邮箱标题：" :label-width="formLabelWidth" v-if="sendform.type === 'email'">
          <el-input v-model="sendform.subject" placeholder="请输入邮件标题" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="sendform.type !== 'email'" label="类型选择：" :label-width="formLabelWidth">
          <el-select v-model="smstype" placeholder="请选择">
            <el-option v-for="item in SmsTypeDatas" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="sendform.type === 'email'" label="邮箱内容：" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="2" placeholder="请输入邮件正文内容" v-model="sendform.content"></el-input>
        </el-form-item>
        <el-form-item v-if="sendform.type !== 'email' && smstype === '会议通知'" label="会议时间：" :label-width="formLabelWidth">
          <el-date-picker v-model="sendform.time" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="sendform.type !== 'email' && smstype === '会议通知'" label="会议地点：" :label-width="formLabelWidth">
          <el-input v-model="sendform.place" placeholder="请输入会议地点" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="sendform.type !== 'email' && smstype === '会议通知'" label="会议内容：" :label-width="formLabelWidth">
          <el-input type="textarea" placeholder="请输入内容" v-model="sendform.content" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="send()">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      center
      :visible.sync="dialogSystem">
      <el-form :model="systemform" class="sendform">
        <el-form-item label="消息类型：" :label-width="formLabelWidth">
          <el-select v-model="systemform.type" placeholder="请选择">
            <el-option v-for="item in SmsTypeData" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息内容：" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="2" placeholder="请输入消息内容" v-model="systemform.content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="sysSend()">发 送</el-button>
        <el-button @click="dialogSystem = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 李旭
 * 会员后台列表页
 */
import filters from '../method/filter'
import {mapState} from 'vuex'
import methods from '../method/methods'
export default {
  mixins: [filters, methods],
  data()
  {
    return {
      form: {
        id: null,
        username: '',
        company: '',
        email: '',
        mobile: '',
        sort: '',
        count: 20,
        areaid: null
      },
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      parms: '',
      member_data: [
        { value: '选项1', label: '注册时间降序', description: 'regtime DESC' },
        { value: '选项2', label: '注册时间升序', description: 'regtime ASC' },
        { value: '选项7', label: '信息ID降序', description: 'id DESC' },
        { value: '选项8', label: '信息ID升序', description: 'id ASC' }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],
      messagesData: [],
      dialogVisible: false,
      dialogSystem: false,
      formLabelWidth: '120px',
      SmsTypeData: [{
        value: 1,
        label: '系统通知'
      }, {
        value: 2,
        label: '矿业咨询服务'
      }],
      SmsTypeDatas: [{
        value: '域名更新通知',
        label: '域名更新通知'
      }, {
        value: '会议通知',
        label: '会议通知'
      }],
      smstype: '',

      sendform: {
        type: 'email',
        subject: '',
        time: '',
        place: '',
        content: ''
      },
      systemform: {
        type: null,
        content: ''
      }
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    if (!this.dialogVisible)
    {
      this.sendform.subject = ''
      this.sendform.content = ''
    }
    this.getList()
    this.urlpath = window.location.href
    this.parms = this.urlpath.substring(this.urlpath.lastIndexOf('/') + 1)
  },
  methods: {
    //获取数据
    getList()
    {
      let count = this.form.count
      let currentPage = this.currentPage
      let exp = ''
      let reorder = ''
      //循环筛选条件
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'username')
          exp += `username like '%${item}%' and `
        if (item && e === 'company')
          exp += `company like '%${item}%' and `
        if (item && e === 'email')
          exp += `email = ${item} and `
        if (item && e === 'mobile')
          exp += `mobile = ${item} and `
        if (item && e === 'areaid' && item !== null)
          exp += `areaid = ${item} and `
        if (item && e === 'sort')
          reorder = `${item}`
      }
      reorder = reorder ? reorder : `regtime DESC`
      exp = exp ? `${exp}id != 0` : 'id > 0 and groupid = 8'
      let paras = {cmd: 'query', _major: 11, _minor: 28,  _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: reorder}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.tableData = []
        ret[0].data.forEach((item) =>
        {
          this.tableData.push({
            id: item.id,
            username: item.username,
            passport: item.passport,
            company: item.company,
            email: item.email,
            mobile: item.mobile,
            regtime: item.regtime
          })
        })
      })
    },
    //发送邮件或者短信的选择以及相关内容配置
    sendtype()
    {
      if (this.messagesData.length === 0)
        this.$message({message: '请先选择会员', type: 'error', customClass: 'mzindex'})
      else
        this.dialogVisible = true
    },
    send()
    {
      if (this.sendform.type === 'email')
      {
        //发送给谁
        let to = ''
        let temp = []
        this.messagesData.forEach(item =>
        {
          temp.push(item.email)
        })
        to = temp.toString()
        if (this.sendform.subject !== '' && this.sendform.content !== '')
        {
          let paras = {
            cmd: 'semdMail',
            //发送给谁
            to: to,
            //发送的标题（仅邮箱使用）
            subject: this.sendform.subject,
            //发送的内容
            content: this.sendform.content,
            name: ''
          }
          window.post.getSendEmail(paras).then((ret) =>
          {
            if (ret.ret === 0)
            {
              this.sendform.subject = ''
              this.sendform.content = ''
              this.dialogVisible = false
              this.$message({message: '邮箱已发送', type: 'success', customClass: 'mzindex'})
            }
          })
        }
        else
          this.$message({message: '请输入您要发送的邮箱标题和邮箱内容', type: 'error', customClass: 'mzindex'})
      }
      else
      {
        //发送给谁
        let phone = ''
        let name = ''
        let tempPhone = []
        let tempName = []
        this.messagesData.forEach(item =>
        {
          tempPhone.push(item.mobile)
          tempName.push(item.passport)
        })
        phone = tempPhone.toString()
        name = tempName.toString()
        if (this.smstype === '域名更新通知')
        {
          let paras = {
            cmd: 'domainNotice',
            _major: 99,
            _minor: 4,
            name: name,
            phone: phone
          }
          window.post.getDmSvr(paras).then((ret) =>
          {
            if (ret.ret === 0)
            {
              this.smstype = ''
              this.dialogVisible = false
              this.$message({message: '短信已发送', type: 'success', customClass: 'mzindex'})
            }
          })
        }
        else if (this.smstype === '会议通知')
        {
          if (this.sendform.time !== '' && this.sendform.place !== '' && this.sendform.content !== '')
          {
            let paras = {
              cmd: 'meetingNotice',
              _major: 99,
              _minor: 4,
              phone: phone,
              name: name,
              time: this.sendform.time,
              place: this.sendform.place,
              content: this.sendform.content
            }
            window.post.getDmSvr(paras).then((ret) =>
            {
              if (ret.ret === 0)
              {
                this.sendform.time = ''
                this.sendform.place = ''
                this.sendform.content = ''
                this.smstype = ''
                this.dialogVisible = false
                this.$message({message: '短信已发送', type: 'success', customClass: 'mzindex'})
              }
            })
          }
          else
            this.$message({message: '发送失败，请将会议通知信息填写完整', type: 'warning', customClass: 'mzindex'})
        }
      }
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/MemberUpdate', query: {id: row.id}})
    },
    setIndexnews(major, minor)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 74, _exp: 'id > 0'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 5 || ret.length === 5)
        {
          this.$alert('添加数据已达上限，此模块数据最多添加5条', '提示', {
            confirmButtonText: '确定'
          })
        }
        else
        {
          if (this.multipleSelection.length + ret.length > 5)
          {
            this.$alert('添加后达数据上限，请重新选择', '提示', {
              confirmButtonText: '确定'
            })
          }
          else
          {
            let newsInfo = []
            this.multipleSelection.forEach(e =>
            {
              newsInfo.push({major: major, minor: minor, newsid: e, addtime: Date.parse(new Date()) / 1000})
            })
            let obj = {
              cmd: 'adds',
              _major: 11,
              _minor: 74,
              json: JSON.stringify(newsInfo)
            }
            window.post.getPost(obj).then((ret) =>
            {
              if (ret.ret === 1)
                this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
              else
              {
                this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
                this.getList()
              }
            })
          }
        }
      })
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
      let obj = {
        cmd: 'query',
        _major: 99,
        _minor: 13,
        _exp: `no = '${row.username}'`
      }
      window.post.getPost(obj).then((ret) =>
      {
        let obj = {
          cmd: 'delete',
          _major: 99,
          _minor: 13,
          id: ret[0].id
        }
        window.post.getPost(obj)
      })
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
      this.messagesData = val
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    // 系统消息发送
    systemtype()
    {
      this.dialogSystem = true
    },
    sysSend()
    {
      let parameter = []
      this.messagesData.forEach(e =>
      {
        parameter.push({type: this.systemform.type, content: this.systemform.content, status: 2, username: e.username, date: (Date.parse(new Date()) / 1000)})
      })
      let param = {
        cmd: 'adds',
        _major: 11,
        _minor: 122,
        json: JSON.stringify(parameter)
      }
      window.post.getPost(param).then((res) =>
      {
        if (res.ret === 0)
        {
          this.$message({message: '发送成功', type: 'success', customClass: 'mzindex'})
          this.systemform = {}
          this.dialogSystem = false
        }
        else
        
          this.$message({message: '发送失败', type: 'error', customClass: 'mzindex'})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/MemberLBss.vue